/* @flow */

import {UploadableFileFieldData} from 'lib/form/uploadable-file-field-data';
import {ValueFieldData} from 'lib/form/value-field-data';

export class PhotoFileFieldData extends UploadableFileFieldData {
    cropperDescriptorData: ValueFieldData;
    type: number;

    constructor(options) {
        const {value = {}, photoFileStore, type = 15} = options;

        super({
            handleUpload: (data) => photoFileStore.create({
                file: data.file,
                type,
                progress: (event) => {
                    const {percent: progress} = event;

                    if (progress) {
                        data.setProgress({
                            progress,
                        });
                    }
                },
            }),
            handleCancel: ({value: photofile}: {value: PhotoFile}) =>
                photofile && photofile.delete(),
            ...options,
        });

        this.cropperDescriptorData = new ValueFieldData({
            value: value.cropperDescriptor,
        });
    }

    computeDirty() {
        return this.cropperDescriptorData.dirty || super.computeDirty();
    }
}
